import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export type RevenueRange = '30d' | '90d' | '12m' | 'all';

export interface RevenueData {
  stats: {
    totalRevenueCents: number;
    thisMonthCents: number;
    last7dCents: number;
    arpuCents: number;
    payingUserCount: number;
  };
  monthlyTrend: { periodLabel: string; revenueCents: number; invoiceCount: number }[];
  weeklyTrend: { periodLabel: string; revenueCents: number; invoiceCount: number }[];
  breakdown: { billingReason: string; invoiceCount: number; revenueCents: number }[];
  health: { status: string; invoiceCount: number; amountDueCents: number; amountPaidCents: number }[];
  topCustomers: { userId: number; displayName: string; totalPaidCents: number; invoiceCount: number; lastPaymentDate: string | null }[];
}

export function useRevenue(range: RevenueRange) {
  return useQuery({
    queryKey: ['revenue', range],
    queryFn: () => apiClient<RevenueData>(`/revenue?range=${range}`),
  });
}
